import { render, staticRenderFns } from "./roleIndex.vue?vue&type=template&id=59c71496&scoped=true&"
import script from "./roleIndex.vue?vue&type=script&lang=js&"
export * from "./roleIndex.vue?vue&type=script&lang=js&"
import style0 from "./roleIndex.vue?vue&type=style&index=0&id=59c71496&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c71496",
  null
  
)

export default component.exports